import { Action, Reducer } from "redux";
import {
	VoucherRefundStatusActionTypes,
	VoucherRefundStatusState,
	VoucherRefundStatusTypes,
} from "./voucherRefundStatusTypes";

export const INITIAL_STATE: VoucherRefundStatusState = {
	voucherRefundStatus: {
		data: null,
		errorMessages: null,
		isError: false,
		isLoading: false,
	},
};

const voucherRefundStatusReducer: Reducer<VoucherRefundStatusState> = (
	state: VoucherRefundStatusState | undefined,
	action: Action,
) => {
	const currentState = state ?? INITIAL_STATE;
	const actionTypes = action as VoucherRefundStatusActionTypes;
	switch (actionTypes.type) {
		case VoucherRefundStatusTypes.GET_VOUCHER_REFUND_STATUS:
			return {
				...currentState,
				voucherRefundStatus: {
					...currentState.voucherRefundStatus,
					isLoading: true,
				},
			};
		case VoucherRefundStatusTypes.SAVE_VOUCHER_REFUND_STATUS:
			return {
				...currentState,
				voucherRefundStatus: {
					...currentState.voucherRefundStatus,
					isLoading: false,
					errorMessages: actionTypes.payload.errorMessages,
					isError: actionTypes.payload.isError,
					data: actionTypes.payload.data,
				},
			};
		case VoucherRefundStatusTypes.RESET_REDUCER_VOUCHER_REFUND_STATUS:
			return {
				...currentState,
				voucherRefundStatus: INITIAL_STATE.voucherRefundStatus,
			};
		default:
			return currentState;
	}
};

export default voucherRefundStatusReducer;
